<template>
  <v-layout row wrap id="create-organization" class="layout-wrapper">
    <v-col>
      <v-flex xs12>
        <v-card class="add-edit-wrapper ma-auto" width="722">
          <div class="close-btn">
            <i class="material-icons dark--text" @click="$router.push('/partner-portal')">
              clear
            </i>
          </div>
          <v-toolbar color="primary" dark class="shadow-none">
            <v-card-title class="headline px-0">
              {{ editMode }} {{ title }}
            </v-card-title>
          </v-toolbar>
          <v-container grid-list-xl fluid class="pb-16px">
            <v-layout row wrap>
              <v-form class="org-form w-100 mt-0" v-model="valid">
                <p class="input-label text-style">
                  Company domain name
                </p>
                <v-text-field
                        class="select-field"
                        label=""
                        name="company_domain_name"
                        v-model="domain"
                        required
                        solo
                        :rules="[rules.required, rules.name]"
                        :validate-on-blur="this.id === 'new'">
                </v-text-field>
                <p class="input-label text-style">
                  Company Name
                </p>
                <v-text-field
                        class="select-field"
                        label=""
                        name="company_name"
                        v-model="name"
                        required
                        solo
                        :rules="[rules.required]"
                        :validate-on-blur="this.id === 'new'">
                </v-text-field>
                <p class="input-label text-style">
                  Company owner
                </p>
                <v-text-field
                        class="select-field"
                        label=""
                        v-model="owner"
                        name="company_owner"
                        required
                        solo
                        :rules="[rules.required]"
                        :validate-on-blur="this.id === 'new'">
                </v-text-field>
                <p class="input-label text-style">
                  Is this company a direct customer, or a channel partner?
                </p>
                <v-select
                  v-model="partner"
                  required
                  name="partner"
                  class="select-field"
                  placeholder="Channel Partner"
                  :menu-props="{ offsetY: true }"
                  validate-on-blur
                  item-text="name"
                  item-value="value"
                  solo
                  :items="channelPartners"
                >
                </v-select>
                <p class="input-label text-style">
                  Select their revenue band
                </p>
                <v-select
                        class="select-field"
                        v-model="band"
                        required
                        :rules="[rules.required]"
                        :items="bands"
                        solo
                        :validate-on-blur="this.id === 'new'">
                </v-select>
                <p class="input-label text-style">
                  Primary contact name
                </p>
                <v-text-field
                        class="select-field"
                        label=""
                        name="primary_contact_name"
                        v-model="contact"
                        required
                        solo
                        :rules="[rules.required, rules.name]"
                        :validate-on-blur="this.id === 'new'">
                </v-text-field>
                <p class="input-label text-style">
                  Primary contact email
                </p>
                <v-text-field
                        class="select-field"
                        label=""
                        name="primary_contact_email"
                        v-model="email"
                        required
                        solo
                        :rules="[rules.required, rules.email]"
                        :validate-on-blur="this.id === 'new'">
                </v-text-field>
              </v-form>
            </v-layout>
          </v-container>
          <v-card-actions class="d-flex flex-column pa-0">
            <v-spacer></v-spacer>
            <v-btn class="save-btn" text @click="saveOrganization()" :disabled="!valid">
              Save
            </v-btn>
            <v-btn class="cancel-btn" text @click="$router.push('/partner-portal')">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-layout></v-layout>
    </v-col>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { validateEmail, validateName, validateSpecialChars, validateNumbers } from '@/utils/main_helper'
import { BANDS } from '@/utils/constants'

export default {
  name: 'OrganizationEditor',
  props: {
    id: {
      type: [String, Number],
      default: 'new'
    },
    title: {
      type: String,
      default: 'Organization'
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      valid: false,
      editMode: 'Create',
      name: '',
      domain: '',
      owner: '',
      partner: '',
      band: '',
      contact: '',
      email: '',
      prevRoute: {},

      channelPartners: [
        {
          name: 'Channel Partner',
          value: 'channel_partner'
        },
        {
          name: 'Customer',
          value: 'customer'
        }
      ],
      rules: {
        required: v => !!v || 'Required.',
        name: v => {
          if (!(v && v.length <= 100)) {
            return 'The field must be less than 100 characters'
          }

          if (!validateName(v)) {
            return 'Contact name must be valid'
          }

          if (!validateName(v)) {
            return 'Contact name must be valid'
          }

          return true
        },
        email: v => validateEmail(v) || 'E-mail must be valid',
        escapeSpecial: v => validateSpecialChars(v) || 'Special Characters are not allowed',
        escapeNumbers: v => !validateNumbers(v) || 'Numbers are not allowed'
      },
      users: [],
      user_ids: []
    }
  },
  mounted () {
    if (this.id !== 'new') {
      this.editMode = 'Edit'
      this.$store.commit('setActiveOrganization', {})
      this.$store.dispatch('loadActiveOrganization', this.id)
    } else {
      this.$store.commit('setActiveOrganization', {})
    }
  },
  computed: {
    ...mapGetters(['activeOrganization', 'currentOrganization', 'user']),
    bands () {
      return BANDS
    }
  },
  methods: {
    saveOrganization () {
      if (this.users === undefined) {
        this.users = [{
          user_id: this.user.user_id,
          name: this.user.name,
          role: 'Admin'
        }]
      }

      if (this.user_ids === undefined) {
        this.user_ids = [this.user.user_id]
      }
      this.setValues(this, this.activeOrganization)
      this.$store.dispatch('saveOrganization', this.activeOrganization)
      this.$router.push('/partner-portal')
    },
    setValues (source, destination) {
      const parentId = this.$route.query?.for
      destination.version = source.version
      if (source.id !== 'new') {
        destination.entity_id = source.entity_id
      }

      destination.name = source.name
      destination.domain = source.domain
      destination.owner = source.owner
      destination.partner = source.partner
      destination.band = source.band
      destination.contact = source.contact
      destination.email = source.email
      destination.users = source.users
      destination.user_ids = source.user_ids
      destination.parent_id = parentId ?? this.currentOrganization.entity_id
    },
    handleClose () {
      this.$emit('onClose')
      if (this.prevRoute.path === '/partner-portal') {
        this.prevRoute = {}
        this.$router.push('/partner-portal')
      } else {
        this.$router.push('/partner-portal')
      }
    }
  },
  watch: {
    activeOrganization () {
      this.setValues(this.activeOrganization, this)
    }
  }
}
</script>

<style scoped>
  .org-form{
    margin-top: 20px;
  }
</style>
